import React from 'react';
import { useTranslation } from 'react-i18next';
import Clickable from '../../Clickable';
import cyanoIcon from '../../../assets/images/cyano.svg';
import ontoIcon from '../../../assets/images/onto.svg';
import styles from './ConnectWallet.module.scss';

export enum LoginMethod {
  Cyano,
  Onto,
}

type Props = {
  onSelect: (method: LoginMethod) => void;
}

const SelectLogin: React.FC<Props> = ({ onSelect }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.select_login__container}>
      <Clickable
        event={() => onSelect(LoginMethod.Cyano)}
        label={t('cyano_wallet')}
        inline={false}
        space={false}
        cursor={false}
      >
        <div className={styles.select_login__item}>
          <div className={styles.select_login__item__label}>{ t('cyano_wallet') }</div>
          <img className={styles.select_login__item__icon} src={cyanoIcon} alt={t('cyano_wallet')} />
        </div>
      </Clickable>
      <Clickable
        event={() => onSelect(LoginMethod.Onto)}
        label={t('onto_wallet')}
        inline={false}
        space={false}
        cursor={false}
      >
        <div className={`${styles.select_login__item} ${styles.select_login__item_second}`}>
          <div className={styles.select_login__item__label}>{ t('onto_wallet') }</div>
          <img className={styles.select_login__item__icon} src={ontoIcon} alt={t('onto_wallet')} />
        </div>
      </Clickable>
    </div>
  );
};

export default SelectLogin;
